import $ from 'jquery';
import { Component } from '../util/component'; // Import to inherit from the Component class

export const Organograma = new Component();

// Get the DOM elements of this component
const organograma = $('.organograma');
const item = organograma.find('.organograma__item');

// On Load
Organograma.pageLoaded = () => {
    if(organograma.length) {
		
		item.on('click', clicked => {
			clicked.preventDefault();

			const el = $(clicked.currentTarget);
			const row = el.closest('.organograma__row');
			
			if (!row.hasClass('active')) {
				row.addClass('active');
				el.find('.content').slideDown('fast');
			} else {
				row.removeClass('active');
				el.find('.content').hide();
			}
			
		})
	}
}